import * as React from "react";

const Byte = (props: any) => (
  <svg width={9} height={10} viewBox="0 0 9 10" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M-6-5h20v20H-6z" />
      <path
        d="M1.75 4.186h2.856c.42 0 .77-.119 1.05-.357s.42-.581.42-1.029c0-.504-.126-.859-.378-1.064-.252-.205-.616-.308-1.092-.308H1.75v2.758zM0 0h4.858c.896 0 1.615.205 2.156.616.541.41.812 1.031.812 1.862 0 .504-.124.936-.371 1.295-.247.36-.6.637-1.057.833v.028c.616.13 1.083.422 1.4.875.317.453.476 1.02.476 1.701 0 .392-.07.758-.21 1.099-.14.34-.36.635-.658.882-.299.247-.681.443-1.148.588-.467.145-1.022.217-1.666.217H0V0zm1.75 8.568h3.094c.532 0 .945-.138 1.239-.413.294-.275.441-.665.441-1.169 0-.495-.147-.875-.441-1.141-.294-.266-.707-.399-1.239-.399H1.75v3.122z"
        fill="#7B838C"
      />
    </g>
  </svg>
);

export default Byte;

